export enum UnitOptionOrganisationMode {
  Unit = 0,
  ExcludeAddOrganisation = 2,
  ChangeUnitOrganisation = 3,
}
